import { ICON__trash_solid } from '@/assets/icons_fa';
import { UI_PRIMITIVE__tooltip } from '@/components/ui/UI_PRIMITIVE__tooltip';
import { use_slice_workspace } from '@/hooks/store/use_slices';
import i18n_base_ui from '@/locales/keys/i18n_base_ui.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { RequestTokensDelete } from '@shared/common/_requests/request_tokens_delete';
import { DTO__token } from '@shared/dto/generation/settings/token/DTO__token';
import { useTranslation } from 'react-i18next';
import { UI_PRIMITIVE__button_with_icon_animated } from '../../../components/ui/UI_PRIMITIVE__button_with_icon_animated';

interface Props {
  item: DTO__token;
  entity_id: string;
  send_request: (request: RequestTokensDelete) => void;
  required_permission: string;
}

export function ButtonTokenDelete({ item, entity_id, send_request, required_permission }: Props) {
  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);

  const { t } = useTranslation(ENUM__i18n_namespace.BASE_UI);

  /*
   * EVENTS
   */
  function onClick(e: React.MouseEvent) {
    let request = new RequestTokensDelete(entity_id, [item.word_english]);

    send_request(request);
  }

  /*
   * METHODS
   */

  if (!current_workspace_user.is_feature_pertmitted(required_permission)) return <></>;

  return (
    <UI_PRIMITIVE__tooltip tooltip_title={t(i18n_base_ui.button.token_delete.tooltip)}>
      <UI_PRIMITIVE__button_with_icon_animated
        variant="no-border-on-component"
        size="icon"
        {...{ onClick }}
        iconClassNameBase="!text-component-item-foreground !w-5 !h-5"
        iconClassNameHovered="!text-bar-foreground"
        Icon={ICON__trash_solid}
      />
    </UI_PRIMITIVE__tooltip>
  );
}
